const searchParams = new URLSearchParams(window.location.search)
const debugMenuItem = () => parseInt(searchParams.get('debugMenuItem'), 10)

export default debugMenuItem
